import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";


export const HeaderWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
}));

export const ProgressContainer = styled(Box)(() => ({
  display: "flex",
  gap: "0.375rem",
}));

export const ProgressBar = styled(Box)(() => ({
  flex: 1,
  height: "0.375rem",
  backgroundColor: "#ebe8e5",
  borderRadius: "9999px",
  overflow: "hidden",
}));

export const ProgressFill = styled(motion.div)(() => ({
  height: "100%",
  borderRadius: "9999px",
  background: "linear-gradient(to right, #0e77da, #0b5fa8)",
}));

export const StepText = styled(Typography)(() => ({
  fontFamily: "Rookery_New, sans-serif",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
  color: "#5f5e60",
}));
